import { render, staticRenderFns } from "./CertificatePeopleSearchModal.vue?vue&type=template&id=f83ada9c&"
import script from "./CertificatePeopleSearchModal.vue?vue&type=script&lang=js&"
export * from "./CertificatePeopleSearchModal.vue?vue&type=script&lang=js&"
import style0 from "./CertificatePeopleSearchModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports